import { apiGateway } from '../api';

async function getLotacoes(numeroContrato) {
    try {
        const response = await apiGateway.get(`/lotacoes/numContrato/${numeroContrato}`);
        return response.data;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function putLotacoes(numero, numeroContrato, body) {
    try {
        const response = await apiGateway.put(`/lotacoes/${numero}/numContrato/${numeroContrato}`, body);

        return response.data.sucesso;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function deleleLotacoes(numero) {
    try {
        const response = await apiGateway.delete(`/lotacoes/${numero}`);

        return response.data.sucesso;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function postLotacoes(numeroContrato, body) {
    try {
        const response = await apiGateway.post(`/lotacoes/numContrato/${numeroContrato}`, body);

        return response.data.sucesso;
    } catch (error) {
        return error.response.data[0] || false;
    }
}

async function getEnderecoLotacao(numeroContrato, codLotacaoTs) {
    try {
        const response = await apiGateway.get(`/lotacoes/${numeroContrato}/${codLotacaoTs}/endereco`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export { getLotacoes, putLotacoes, deleleLotacoes, postLotacoes, getEnderecoLotacao };
